import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error?.response?.status === 401) {
            location.href = '/login?loginstatus=autologout';
        }
        return error;
    }
);

window.cdnUrl = import.meta.env.VITE_DO_CDN_ENDPOINT;

import './echo';

export { axios };
